export const messages = {
  titleLabel: {
    id: 'authoring.videoeditor.videoSource.title.label',
    defaultMessage: 'Video Source',
    description: 'Title for the video source widget',
  },
  videoIdOrUrlLabel: {
    id: 'authoring.videoeditor.videoSource.videoIdOrUrl.label',
    defaultMessage: 'Video ID or URL',
    description: 'Label for video ID or URL field',
  },
  videoIdOrUrlFeedback: {
    id: 'authoring.videoeditor.videoSource.videoIdOrUrl.feedback',
    defaultMessage: `Your video ID, YouTube URL, or a link to an .mp4, .ogg, or
    .webm video file hosted elsewhere on the Internet`,
    description: 'Feedback for video ID or URL field',
  },
  fallbackVideoTitle: {
    id: 'authoring.videoeditor.videoSource.fallbackVideo.title',
    defaultMessage: 'Fallback Videos',
    description: 'Title for the fallback videos section',
  },
  fallbackVideoMessage: {
    id: 'authoring.videoeditor.videoSource.fallbackVideo.message',
    defaultMessage: `To be sure all learners can access the video, edX
    recommends providing additional videos in both .mp4 and
    .webm formats.  The first listed video compatible with the
    learner's device will play.`,
    description: 'Test explaining reason for fallback videos',
  },
  fallbackVideoLabel: {
    id: 'authoring.videoeditor.videoSource.fallbackVideo.label',
    defaultMessage: 'Video URL',
    description: 'Label for fallback video url field',
  },
  deleteFallbackVideo: {
    id: 'authoring.videoeditor.videoSource.deleteFallbackVideo',
    defaultMessage: 'Delete',
    description: 'Message Presented To user for action to delete fallback video',
  },
  allowDownloadCheckboxLabel: {
    id: 'authoring.videoeditor.videoSource.allowDownloadCheckboxLabel',
    defaultMessage: 'Allow video downloads',
    description: 'Label for allow video downloads checkbox',
  },
  tooltipMessage: {
    id: 'authoring.videoeditor.videoSource.fallbackVideo.allowDownloadTooltipMessage',
    defaultMessage: `Allow learners to download versions of this video in
    different formats if they cannot use the edX video player or do not have
    access to YouTube.`,
    description: 'Message for allow video downloads checkbox',
  },
  addButtonLabel: {
    id: 'authoring.videoeditor.videoSource.fallbackVideo.allowDownloadTooltipMessage',
    defaultMessage: 'Add a video URL',
    description: 'Label for add a video URL button',
  },
};

export default messages;
